import { atom } from "jotai";
import { BuiltInApp } from "../types";

export const agentsAppAtom = atom<BuiltInApp | null>(null);
agentsAppAtom.debugLabel = "agentsAppAtom";
